// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__30VR1","bigColWidth":"Table_bigColWidth__3iTiT","biggerColWidth":"Table_biggerColWidth__3cv7l","row":"Table_row__1h4x0","col":"Table_col__ju2sG"};